import Carousel from 'client/components/Carousel';
import CartWrapper from './cart/CartWrapper';
export default class EinsteinCarousel extends Carousel {
    // eslint-disable-next-line consistent-return
    init() {
        super.init();
        CartWrapper.addClassEinstentCarousel();
    }
}
